import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/strategy/business-plan')({
  component: () => <PageStub title="Business Plan" description="Business planning and strategy" />,
});
